import type { MeResponse, Rule } from '@alerts/shared'
import { RuleCard } from '../components/RuleCard'

type Props = {
  me: MeResponse
  onEdit: (rule: Rule) => void
  onAddMarket: () => void
  onToggleEnabled: (rule: Rule, enabled: boolean) => void
  onDelete: (rule: Rule) => void
}

export function Home({ me, onEdit, onAddMarket, onToggleEnabled, onDelete }: Props) {
  const total = me.rules
    .filter((r) => r.enabled)
    .reduce((acc, r) => acc + r.tickers.length * r.timeframes.length * r.pois.length * r.types.length, 0)

  const usedMarkets = new Set(me.rules.map((r) => r.market))
  const availableMarkets = me.config.markets.filter((m) => !usedMarkets.has(m))

  return (
    <div className="app">
      <div style={{ marginBottom: 14 }}>
        <div className="label">Active alerts</div>
        <div style={{ fontSize: 28, fontWeight: 700 }}>{total}</div>
      </div>

      {me.rules.map((r) => (
        <RuleCard
          key={r.id}
          rule={r}
          onEdit={() => onEdit(r)}
          onToggleEnabled={(next) => onToggleEnabled(r, next)}
          onDelete={() => onDelete(r)}
        />
      ))}

      {availableMarkets.length > 0 && (
        <button type="button" className="btn-add" onClick={onAddMarket}>
          + Add market
        </button>
      )}
    </div>
  )
}
